import InsightHighlightsAction from '../redux/actions/insightHighlights/InsightHighlightsAction'
import { container, TYPES } from '../inversifyconfig/container.config'
import { IInternalAuth } from '../interfaces/inversifyDi'
import { ProcessHttp } from '../helpers/Auth'
import moment from 'moment';
import { IHttpRequest } from  '@/interfaces/IHttp';
import { removeTime, removeTimeZone } from  '@/helpers/Dates';


class InsightHighlightsWebService {

  router = store => dispatch => action => {
    switch (action.type) {
      case InsightHighlightsAction.REQUEST_INSIGHT_HIGHLIGHTS:

        // If doest have token
        if (!ProcessHttp()){
          return dispatch(action)
        }

        // Prev 7 days - same as main page call
        const orgStart = moment().subtract(7,'d').hour(12).toDate();
        const orgEnd = moment().subtract(1,'d').hour(12).toDate();

        let orgShortCode = window.location.host.split('.')[0];

        this.internalAuth().Check().then(() => { 

          // No cache
          this.httpRequest().setHeaders({
            'Cache-control': 'no-cache',
            'Pragma': 'no-cache',
            'Expires': '0'    
          });

          this.httpRequest().get(
            `/insights/dashboard-summary?&dateFrom=${removeTimeZone(orgStart)}&dateTo=${removeTimeZone(orgEnd)}`
          ) 
          .then((x) => {
            store.dispatch(InsightHighlightsAction.receiveInsightHighlights(x.data))
          })
          .catch((e) => {
            console.error(e.message)
          })
        })
        return dispatch(action)
      default:
        return dispatch(action)
    }
  }

  httpRequest() {
    return container.get<IHttpRequest>(TYPES.IHttpRequest);  
  }

  internalAuth() {
    return container.get<IInternalAuth>(TYPES.IInternalAuth)
  }
}

export default InsightHighlightsWebService